import { SummarySum, SummaryText, SummaryWrapper } from "./summaryStyled";

import { VALUE_TYPE } from "Components/NumberValue";
import { formatToLocaleString } from "Formatting/formatNumber";
import React from "react";

interface Props {
  text: string;
  sum: number;
  valueType: VALUE_TYPE;
}

export const Summary = ({
  text,
  sum,
  valueType,
}: Props): React.ReactElement | null => {
  if (sum === 0) {
    return null;
  }

  return (
    <SummaryWrapper>
      <SummaryText className="AdviceTextsReason">{text}</SummaryText>
      <SummarySum className="AdviceTextsReason">
        {`${formatToLocaleString(Math.trunc(sum))}${"\u2009"}${valueType}`}
      </SummarySum>
    </SummaryWrapper>
  );
};
